export default {
  storefront_not_found: {
    title: 'Nicio vitrină găsită',
    description: 'Vă rugăm să creați o vitrină.',
  },
};
